export default function CaseStudies() {
  const metrics = [
    {
      stat: 'Reduced processing time by 47%',
      description: 'for a multi-location professional services firm.',
    },
    {
      stat: 'Eliminated manual data handling',
      description: 'across core workflows for a regulated organization.',
    },
    {
      stat: 'Improved operational visibility',
      description: 'through real-time intelligence dashboards.',
    },
  ];

  return (
    <section className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 border border-white/20 text-white/80 text-xs font-medium rounded-full mb-6">
            CASE STUDY PREVIEW
          </span>
          <h2 className="text-5xl font-bold text-white mb-4">
            Operational Breakthroughs in Action
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border-l-4 border-teal-500 hover:bg-white/10 transition-colors"
            >
              <h3 className="text-3xl font-bold text-white mb-4 leading-tight">
                {metric.stat}
              </h3>
              <p className="text-base text-slate-300 leading-relaxed">
                {metric.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm italic text-slate-400">
          (Full case studies available upon request.)
        </p>
      </div>
    </section>
  );
}
